import { apiServices } from '../services/api.services';
import i18n from 'i18next';
import store from '../store';
import { lng } from '../../i18n/cfg.json';
import { toast } from 'react-toastify';

const rooms = [
    {
        room: 'discord',
        plan: 2
    },
    {
        room: 'ingame',
        plan: 2
    },
    {
        room: 'distance',
        plan: 3
    },
    {
        room: 'discord.sendDeaths',
        plan: 3
    },
    {
        room: 'discord.sendStatus',
        plan: 3
    },
    {
        room: 'ingame.trackDeaths',
        plan: 3
    }
];
  
export const settingsEventSwitch = (room, key, value) => {
    var found = rooms.findIndex(f => f.room === room);
    if (found > -1) {
      if (store.getState().infos.vip.plan < rooms[found].plan) return toast.info(i18n.t('common:featureNotAvailable'));
    } else return;
    return async (Dispatch) => {
        const args = {
            key,
            place: room,
            state: value
        };
        await apiServices.post("/setEventSetting", args).then((res) => {
            res && res.data && res.data.success && Dispatch({type: 'SETTINGS_SWITCH_EVENTS', key, room, value});
        }).catch(err => {
            return err;
        });
    };
};

export const settingsDiscordSwitch = (key, value) => {
    return async (Dispatch) => {
        const args = {
            key: `discord.channel.${key}`,
            state: value
        };
        await apiServices.post("/setSetting", args).then((res) => {
            res && res.data && res.data.success && Dispatch({type: 'SETTINGS_SWITCH_CHANNELS', key, value});
        }).catch(err => {
            return err;
        });
    };
};

export const settingsSwitch = (key, value) => {
    return async (Dispatch) => {
        const args = {
            key: key,
            state: value
        };
        var found = rooms.findIndex(f => f.room === key);
        if ((found > -1) && (store.getState().infos.vip.plan < rooms[found].plan)) return toast.info(i18n.t('common:featureNotAvailable'));
        await apiServices.post("/setSetting", args).then((res) => {
            res && res.data && res.data.success && Dispatch({type: 'SETTINGS_SWITCH', key, value});
        }).catch(err => {
            return err;
        });
    };
};

export const settingsSetLang = (lang) => {
    var {logged} = store.getState().rLink;
    if (!lng.includes(lang)) {
        lang = "en";
        toast.info(i18n.t('common:languageSelectedNotFound'));
    }
    var { locale } = store.getState().settings;
    if (locale === lang) return;
    i18n.changeLanguage(lang);
    store.dispatch({type: 'SET_LANG', locale: lang});
    if (logged)
        apiServices.post("/setSetting", {
            key: 'locale',
            state: lang
        });
};

export const settingsInit = (Dispatch, settings) => {
    if (!lng.includes(settings.locale)) {
        settings.locale = "en";
    }
    i18n.changeLanguage(settings.locale);
    return Dispatch({type: 'INIT_SET_SETTINGS', settings});
}